var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outlined-label",class:{'active': _vm.active},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }